import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class DepositProductService {

  baseAccountUrl: string = environment.baseUrl + environment.accountUrl;

  constructor(private http: HttpClient) { }

  public createDepositProduct(data) {
    return this.http.post<any>(`${this.baseAccountUrl}savings-products`, data);
  }

  public updateDepositProduct(depositProductId: number, data: any) {
    return this.http.put<any>(`${this.baseAccountUrl}savings-products/${depositProductId}`, data);
  }

  public getDepositProducts(params: string) {
    return this.http.get(`${this.baseAccountUrl}savings-products?${params}`);
  }

  public getDepositProduct(loanProductId) {
    return this.http.get(`${this.baseAccountUrl}savings-products/${loanProductId}`);
  }

  public toggleDepositProducts(data:any): Observable<any>{
    return this.http.put<any>(`${this.baseAccountUrl}savings-products/toggle`, data);
  }

  public compareDepositProducts(depositProductId: number): Observable<any>{
    return this.http.get<any>(`${this.baseAccountUrl}savings-products/${depositProductId}/compare`);
  }

  public approveRejectDepositproduct(depositProductId: number, data: { state: string }) {
    return this.http.put<any>(`${this.baseAccountUrl}savings-products/${depositProductId}/approve-edit`, data);
  }

  public getEventMappings():Observable<any> {
    return this.http.get(`${this.baseAccountUrl}savings-products/mappings`);
  }

  public getFeeEvents(): Observable<any> {
    return this.http.get<any>(`${this.baseAccountUrl}loan-product-fee-config/fee-events`);
  }

  public calculateDepositAccountProjection(data: {
    averageBalance: number;
    interestRate: number;
    interestRatePeriodUnit: string;
    compoundingPeriodUnit: string;
    interestPostingPeriodUnit: string;
  }): Observable<any> {
    return this.http.post<any>(
      `${this.baseAccountUrl}savings-calculator/deposit-account-projection`,
      data
    );
  }

  public calculateFixedDepositProjection(data: {
    amount: number;
    duration: number;
    durationPeriodUnit: string;
    interestRate: number;
    interestPeriodUnit: string;
    compoundingPeriodUnit: string;
    earlyWithdrawalDay: number;
    prematureWithdrawalPenaltyType: string;
    prematureWithdrawalPenaltyOnInterest: number;
  }): Observable<any> {
    return this.http.post<any>(
      `${this.baseAccountUrl}savings-calculator/fixed-deposit-projection`,
      data
    );
  }

  public calculateRecurringTargetedProjection(data: {
    targetAmount: number;
    duration: number;
    durationPeriodUnit: string;
    interestRate: number;
    interestPeriodUnit: string;
    savingsFrequency: string;
    bonusOnCompletionEnabled: boolean;
    bonusType: string;
    bonusValue: number;
  }): Observable<any> {
    return this.http.post<any>(
      `${this.baseAccountUrl}savings-calculator/recurring-targeted-projection`,
      data,
    );
  }
}
